import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const AppLinkFallbackPage = () => {
  const location = useLocation();

  const path = location.pathname.replace(/^\/dl/, '');
  const schemeUrl = `findmecourts://${path}`;
  const playStoreUrl = "https://play.google.com/store/apps/details?id=com.gencoft.findmecourts";
  const appStoreUrl = "https://apps.apple.com/app/id6480585243";
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const storeUrl = isIOS ? appStoreUrl : playStoreUrl;

  useEffect(() => {
    const fallbackTimeout = setTimeout(() => {
      window.location.href = storeUrl;
    }, 2000);
  
    if (isIOS) {
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = schemeUrl;
      document.body.appendChild(iframe);
  
      // Optionally remove iframe after a while
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    } else {
      window.location.href = schemeUrl;
    }
  
    return () => clearTimeout(fallbackTimeout);
  }, [schemeUrl, storeUrl, isIOS]);
  

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h2>Opening the app…</h2>
      <p>
        If nothing happens, <a href={storeUrl}>tap here to download it.</a>
      </p>
    </div>
  );
};

export default AppLinkFallbackPage;